import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", null, "Bonifici", -1)
const _hoisted_2 = {
  width: "100",
  filter: "createdOn",
  filterType: "dateRange",
  filterFrom: "fromDate",
  filterTo: "toDate",
  sort: "createdOn"
}
const _hoisted_3 = {
  filter: "cliente",
  sort: "cliente.name"
}
const _hoisted_4 = {
  filter: "offers",
  sort: "offers"
}
const _hoisted_5 = {
  width: "80",
  filter: "importo",
  sort: "importo"
}
const _hoisted_6 = {
  width: "100",
  filter: "valuta",
  sort: "valuta"
}
const _hoisted_7 = {
  width: "100",
  filter: "confirmedOn",
  filterType: "dateRange",
  filterFrom: "approvedFromDate",
  filterTo: "approvedToDate",
  sort: "confirmedOn"
}
const _hoisted_8 = {
  width: "80",
  filter: "documentoCaricato",
  filterType: "checkbox",
  sort: "documentUrl",
  class: "text-center"
}
const _hoisted_9 = {
  width: "100",
  filter: "disabled",
  filterType: "checkbox",
  sort: "disabled",
  class: "text-center"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", { width: "80" }, null, -1)
const _hoisted_11 = {
  key: 0,
  width: "160"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { colspan: "99" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = {
  key: 0,
  class: "fa fa-check"
}
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = {
  key: 0,
  class: "fa fa-times"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Dettaglio")
const _hoisted_24 = { key: 0 }
const _hoisted_25 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_op_table, {
      class: "table table-striped",
      itemsPerPage: _ctx.filter.perPage,
      items: _ctx.tableResult.data,
      filter: _ctx.filter,
      totalItemsCount: _ctx.tableResult.count,
      onSearch: _ctx.search
    }, {
      default: _withCtx((opData) => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_2, [
              _createVNode(_component_localized_text, {
                localizedKey: "Data",
                text: "Data"
              })
            ]),
            _createElementVNode("td", _hoisted_3, [
              _createVNode(_component_localized_text, {
                localizedKey: "Cliente",
                text: "Cliente"
              })
            ]),
            _createElementVNode("td", _hoisted_4, [
              _createVNode(_component_localized_text, {
                localizedKey: "Carrello",
                text: "Carrello"
              })
            ]),
            _createElementVNode("td", _hoisted_5, [
              _createVNode(_component_localized_text, {
                localizedKey: "Importo",
                text: "Importo"
              })
            ]),
            _createElementVNode("td", _hoisted_6, [
              _createVNode(_component_localized_text, {
                localizedKey: "Valuta",
                text: "Valuta"
              })
            ]),
            _createElementVNode("td", _hoisted_7, [
              _createVNode(_component_localized_text, {
                localizedKey: "Approvato il",
                text: "Approvato il"
              })
            ]),
            _createElementVNode("td", _hoisted_8, [
              _createVNode(_component_localized_text, {
                localizedKey: "Documento caricato",
                text: "Documento caricato"
              })
            ]),
            _createElementVNode("td", _hoisted_9, [
              _createVNode(_component_localized_text, {
                localizedKey: "Annullato",
                text: "Annullato"
              })
            ]),
            _hoisted_10,
            (_ctx.$store.state.isAdmin())
              ? (_openBlock(), _createElementBlock("td", _hoisted_11))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("tbody", null, [
          (opData.items.length == 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                _createElementVNode("td", _hoisted_13, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Nessun elemento trovato",
                    text: "Nessun elemento trovato"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((opData.items as OM.PagamentoBonifico[]), (item, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", null, _toDisplayString(_ctx.$filters.date(item.createdOn, "YYYY-MM-DD HH:mm")), 1),
              _createElementVNode("td", null, _toDisplayString(item.cliente ? item.cliente.name : ''), 1),
              _createElementVNode("td", null, [
                (item.offers.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("u", {
                        class: "pointer",
                        onClick: ($event: any) => (_ctx.openOffersModal(item.offers))
                      }, [
                        _createTextVNode(_toDisplayString(item.offers.length) + " ", 1),
                        _createVNode(_component_localized_text, {
                          localizedKey: "elementi",
                          text: "elementi"
                        })
                      ], 8, _hoisted_15),
                      _hoisted_16,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.offers, (offer, i) => {
                        return (_openBlock(), _createElementBlock("div", { key: i }, [
                          _createElementVNode("small", null, "- " + _toDisplayString(offer.name), 1)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", null, _toDisplayString(_ctx.$filters.currency(item.importo)), 1),
              _createElementVNode("td", null, _toDisplayString(item.valuta), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.$filters.date(item.confirmedOn)), 1),
              _createElementVNode("td", _hoisted_17, [
                (item.documentUrl || item.comments.some(c => c.attachments.length > 0 || c.attachmentUrl))
                  ? (_openBlock(), _createElementBlock("i", _hoisted_18))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", _hoisted_19, [
                (item.disabled)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_20))
                  : _createCommentVNode("", true),
                _hoisted_21,
                _createTextVNode(" " + _toDisplayString(_ctx.$filters.date(item.disabledOn, 'YYYY-MM-DD')), 1),
                _hoisted_22,
                _createTextVNode(" " + _toDisplayString(_ctx.$filters.date(item.disabledOn, 'HH:mm')), 1)
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_router_link, {
                  class: "btn btn-sm btn-primary",
                  to: '/pagamentoBonifico/' + item.identifier
                }, {
                  default: _withCtx(() => [
                    _hoisted_23
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              (_ctx.$store.state.isAdmin())
                ? (_openBlock(), _createElementBlock("td", _hoisted_24, [
                    (!item.confirmedOn && !item.disabled)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn btn-sm btn-red",
                          onClick: ($event: any) => (_ctx.annulla(item))
                        }, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Annulla",
                            text: "Annulla"
                          })
                        ], 8, _hoisted_25))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["itemsPerPage", "items", "filter", "totalItemsCount", "onSearch"])
  ]))
}